import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthContextProvider } from "./context/AuthContext";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { BrowserRouter } from "react-router-dom";
// Disable React error overlay
if (process.env.NODE_ENV === "development") {
  try {
    const { ReactErrorOverlay } = require("react-error-overlay");
    ReactErrorOverlay.stopReportingRuntimeErrors();
  } catch (e) {
    console.log("React Error Overlay could not be disabled.");
  }
}

// Function to load Google Publisher Tag script dynamically
const loadGPTScript = () => {
  const script = document.createElement("script");
  script.src = "https://securepubads.g.doubleclick.net/tag/js/gpt.js";
  script.async = true;
  document.head.appendChild(script);
};

// Load GPT script
loadGPTScript();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthContextProvider>
        <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
          <App />
        </GoogleOAuthProvider>
      </AuthContextProvider>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
